import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Actions from "../../../Actions";
import Form from "./Form";
import Tile from "../Layout/Tile";


class Edit extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
    }

    componentDidUpdate(){
        if(this.props.companyStore.alert && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });      
    }

    render = () => {

        const { editCompany, companyStore: { alert: { edit } }, modalStore:{edit: { modal, data, data: { id = false} }}, toggleModal} = this.props;
        
        return (
            <div>
                <Modal size="lg" isOpen={modal} toggle={() => toggleModal("companies","edit")}>
                    <ModalHeader toggle={() => toggleModal("companies","edit")}>Edit Company</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>    
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {edit !== false &&
                                    <Alert color={edit.type}>
                                        {edit.message}
                                    </Alert>
                                }
                                <Form data={data} id={id} persist={editCompany} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    companyStore: state.companyStore,
    modalStore: state.modalStore.companies,
});

const { companies, modals } = Actions; 

export default connect(mapStateToProps, { ...companies, ...modals } )(Edit);


// WEBPACK FOOTER //
// ./src/Components/App/Companies/Edit.js